import React, { useEffect, useState } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import axios from "axios";
import { get_all_contact_us, get_all_contractor } from "../../Services/APIService";


export default function Contactus() {

    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState();
    const [color, setColor] = useState();

    useEffect(() => {
        axios({
            method: 'GET',
            url: get_all_contact_us,
        }).then(res => {
            if (!res.data.error) {
                setMessage(res.data.message)
                setOpen(true)
                setStatus(false)
                setColor(false)
                setData(res.data.data)
            } else {
                setMessage(res.data.message)
                setOpen(true)
                setStatus(true)
                setColor(true)
            }
        }).catch(err => {
            alert('Oops something went wrong ' + err)
        });
    }, [])

    return (
        <Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>S.No</TableCell>
                            <TableCell>Customer Name</TableCell>
                            <TableCell>Customer Mail</TableCell>
                            <TableCell>Customer Mobile</TableCell>
                            <TableCell>Customer Company</TableCell>
                            <TableCell>Customer Country</TableCell>
                            <TableCell>Customer City</TableCell>
                            <TableCell>Comments</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{item.customerName}</TableCell>
                                <TableCell>{item.customerMail}</TableCell>
                                <TableCell>{item.customerMobile}</TableCell>
                                <TableCell>{item.customerCompany}</TableCell>
                                <TableCell>{item.customerCountry}</TableCell>
                                <TableCell>{item.customerCity}</TableCell>
                                <TableCell>{item.comments}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}
